import type { CheckboxGroupProps } from './CheckboxGroup';

export type OldCheckboxGroupProps<CheckboxValue> = Omit<CheckboxGroupProps<CheckboxValue>, 'hasSelectAll'> & {
  /** @deprecated hasSelectAll을 대신 사용해주세요. */
  allCheck?: boolean;
};

export function convertOldCheckboxGroupProps<CheckboxValue>(
  props: OldCheckboxGroupProps<CheckboxValue>,
): CheckboxGroupProps<CheckboxValue> {
  const { allCheck, ...restProps } = props;

  return {
    ...restProps,
    hasSelectAll: allCheck,
  };
}
